export class UserLogDto {

  UserName: string;
  LogonTime: string;
  LogoutTime: string;
  ClientIp: number;
  LoginDevice: number;
}


export class UserLogSearchDto {
  LoginDevice: string;
  UserName: string;
  FromDate: string;
  ToDate: string;
  PageNo: number;
  PageSize: number;
}
export class UserRole {
  UserRoleId: string;
  Name: string
}

export class ChangePassword {
  UserId: string;
  Password: string;
  ConfirmPassword: string;
  NewPassword:string;
}

export class UserModel {
  Id: string;
  Email: string;
  MobileNo: string;
  FirstName: string;
  LastName: string;
  UserName: string;
  AddedDate: string;
  ModuleName: string;
  AccessId: string;
  ClientId: string;
  DpId: string;
  IsSelfAcc: boolean;
  SelfAcc: string;
  FriendlyAccName: string;
  Pan: string;
  Role: string;
  Password: string;
  ConfirmPassword: string;
  SaveAndNext: boolean;
  IsClient: boolean;
  MobileNumber: string;
  ClientName: string;
  PageNo: number;
  PageSize: number;

}
